import React from 'react';
import { 
    Responsive, // eslint-disable-line
    List, SimpleList, Datagrid, // eslint-disable-line
    Edit, Create, Filter, // eslint-disable-line
    EditButton, SimpleForm, TabbedForm, FormTab, // eslint-disable-line
    NumberInput, TextInput, LongTextInput, BooleanInput, SelectInput, SelectArrayInput, ReferenceInput, ReferenceArrayInput, DisabledInput, ImageInput, // eslint-disable-line
    NumberField, TextField, DateField, BooleanField, ReferenceField, ReferenceArrayField, SingleFieldList, ChipField, ImageField, EmailField, PasswordField // eslint-disable-line
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
// import CustomImageField from '../fields/CustomImageField';
import IconField from '../fields/IconField';
import { PAGE_ICONS } from '../constants/icons';

const PagesFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="name" alwaysOn />
        <BooleanInput label="Online" source="online" />
        <ReferenceInput label="Creator" source="createdBy" reference="users" allowEmpty>
            <SelectInput optionText="name" />
        </ReferenceInput>
    </Filter>
);

export const PagesList = (props) => (
    <List {...props} filters={<PagesFilter />} bulkActions={false}>
        <Responsive
            small={
                <SimpleList
                    primaryText={record => record.name}
                    secondaryText={record => record.slug}
                    tertiaryText={record => record.key}
                    // tertiaryText={record => new Date(record.createdAt).toLocaleDateString()}
                />
            }
            medium={
                <Datagrid>
                    <BooleanField source="online" />
                    <TextField source="name" />
                    <TextField source="key" />
                    <TextField source="template" />
                    <IconField source="icon" />
                    <NumberField source="nav" />
                    {/*<ReferenceField source="createdBy" reference="users">
                        <TextField source="name" />
                    </ReferenceField>*/}
                    <EditButton />
                </Datagrid>
            }
        />
    </List>
);

const PagesTitle = ({ record }) => {
    return <span>Page {record ? `"${record.name}"` : ''}</span>;
};

export const PagesEdit = (props) => (
    <Edit name={<PagesTitle />} {...props}>
        <TabbedForm>
            <FormTab label="Global">
                <TextInput source="name" />
                <DisabledInput source="slug" />
                <TextInput source="desc" />
            </FormTab>
            <FormTab label="Content">
                <RichTextInput source="content" />
            </FormTab>
            <FormTab label="Settings">
                <BooleanInput source="online" />
                <TextInput source="key" />
                <TextInput source="template" />
                <SelectInput source="icon" allowEmpty choices={PAGE_ICONS} optionText={<IconField source="id" />}/>
                <NumberInput source="nav" />
            </FormTab>
            <FormTab label="Meta">

                <ReferenceField source="createdBy" reference="users" allowEmpty={true}>
                    <TextField source="name" />
                </ReferenceField>
                <DateField source="createdAt" showTime />

                <ReferenceField source="updatedBy" reference="users" allowEmpty={true}>
                    <TextField source="name" />
                </ReferenceField>
                <DateField source="updatedAt" showTime />

            </FormTab>
        </TabbedForm>
    </Edit>
);

export const PagesCreate = (props) => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="name" />
            <LongTextInput source="desc" />
            {/*<ReferenceInput label="User" source="createdBy" reference="users">
                <SelectInput optionText="name" />
            </ReferenceInput>*/}
        </SimpleForm>
    </Create>
);